import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { defaultImage, getUrlBookCover } from '../../../../../common-sk-doc/src/utils/image';
import {
  bannerHDOT,
  BookType,
  ChapterType,
} from '../../../../../ui/src/common/book/BookHelpers';
import BookExtraResource from '../../components/BookExtraResource';
import BookChapter from '../../BookChapter';
import { useBookContext } from '../../BookContext';
import config from '../../../../../common-sk-doc/src/config';

const BookViewNormal: React.FC = () => {
  const {
    book,
  } = useBookContext();

  const [sectionIndex, setSectionIndex] = useState(-1);
  return (
    <Row>
      <Col md={2}>
        <div className="book-ref">
          <div className="text-center position-relative">
            <img
              src={getUrlBookCover(book)}
              onError={(e) =>
                defaultImage(
                  e,
                  config.ASSETS_PATH + '/images/home/default_book.svg',
                )
              }
              alt=""
            />
          </div>
          <div className="book-mark mt-3">
            {book.chapters.map((c, i) => (
              <a
                key={i}
                href={`#section-${i}`}
                className={`${sectionIndex === i ? 'active' : ''} ${c.type === ChapterType.Default ? '' : 'mark-parent'
                  }`}
                onClick={(e) => {
                  setSectionIndex(i);
                }}>
                <span>{c.name}</span>
              </a>
            ))}
          </div>
        </div>
      </Col>
      <Col md={10}>
        {book.type === BookType.HDOT && (
          <div className="ads-checkpoint mb-3">
            <img
              src={
                bannerHDOT.find((b) => b.code === book?.subject?.code)?.image ||
                ''
              }
              alt=""
            />
            <div className="vertical-center">
              <Button onClick={
                () => {
                  // navigate('/luyen-thi')
                }
              }>
                {'Trải nghiệm ngay' /*Translate('experience-now', 'Trải nghiệm ngay')*/}
              </Button>
            </div>
          </div>
        )}
        <div
          className={`book-card mb-3 p-2 ${book.type === 3 ? 'book-card-checkpoint' : ''
            }`}>
          <div className="book-name d-flex" style={{ alignItems: 'center' }}>
            <div className="me-auto">{book.name}</div>
            <BookExtraResource extraResources={book.extraResources} />
          </div>
          <div className="book-desc">{book.description}</div>
        </div>

        {book.chapters.map((c, i) => (
          <BookChapter
            key={i}
            chapter={c}
            index={i}
          />
        ))}
      </Col>
    </Row>
  );
};

export default BookViewNormal;
